// 商品路由管理
export default{
    path: 'goods',
    name: 'goods',
    component: () => import('@/components/RouterView'),
    redirect: '/manage/goods/list',
    meta: {title: '商品管理'},
    children: [{
        path: 'list',
        name: 'goodsList',
        component: () => import('@/views/manage/goods/list'),
        // 列表页自渲染标题+「新增商品」按钮（灰度控制），layout 标题关闭
        meta: {title: '商品列表',showTitle:false}
    }
    ,{
        path: 'deliver',
        name: 'goodsDeliver',
        component: () => import('@/views/manage/goods/deliver'),
        meta: {title: '商品发货',showTitle:true}
    }
    ,{
        path: 'edit',
        name: 'goodsEdit',
        component: () => import('@/views/manage/goods/edit'),
        meta: {title: '新增商品',showTitle:false}
    }
    ,{
        path: 'edit/:id',
        name: 'goodsEditById',
        component: () => import('@/views/manage/goods/edit'),
        meta: {title: '编辑商品',showTitle:false}
    }]
}